export default __webpack_public_path__ + "static/media/camera_menu_item.28037317.svg";